import { render, staticRenderFns } from "./CompanyReferentsCnaTable.vue?vue&type=template&id=29ad84ec&scoped=true&"
import script from "./CompanyReferentsCnaTable.vue?vue&type=script&lang=ts&"
export * from "./CompanyReferentsCnaTable.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29ad84ec",
  null
  
)

export default component.exports